
import React, { useReducer, useState } from 'react';
import { NAME, VALUE } from '../actions/value.action';
import BudgetAction from '../components/BudgetAction';
import Leftover from '../components/Leftover';
import SaveData from '../components/SaveData';
import Tables from '../components/Tables';
import { BudgetContext } from '../context';
import { BLANK_PAYLOAD } from '../helpers/constants';
import { sum } from '../helpers/functions/math';
import valueReducer from '../reducers/value.reducer';
const CreateBudget = () => {
    // login related
    const [show, setShow] = useState(false)

    // budget related
    const [expenses, setExpenses] = useState([])
    const [incomes, setIncomes] = useState([])

    const [expensePayload, dispatchExpense] = useReducer(valueReducer, BLANK_PAYLOAD)
    const [incomePayload, dispatchIncome] = useReducer(valueReducer, BLANK_PAYLOAD)

    const addIncome = (e) => {
        e.preventDefault()
        setIncomes([...incomes, incomePayload])
    }
    const addExpense = (e) => {
        e.preventDefault()
        setExpenses([...expenses, expensePayload])
    }

    const clearIncome = (e) => {
        e.preventDefault()
        setIncomes([])
    }
    const clearExpense = (e) => {
        e.preventDefault()
        setExpenses([])
    }

    const deleteIncomeRow = (index) => {
        const rows = [...incomes]
        rows.splice(index, 1)
        setIncomes(rows)
    }
    const deleteExpenseRow = (index) => {
        const rows = [...expenses]
        rows.splice(index, 1)
        setExpenses(rows)
    }

    const handleIncomeName = (e) => dispatchIncome(NAME(e.target.value))
    const handleExpenseName = (e) => dispatchExpense(NAME(e.target.value))

    const selectIncomeName = (e) => dispatchIncome(NAME(e))
    const selectExpenseName = (e) => dispatchExpense(NAME(e))

    const handleIncomeValue = (e) => dispatchIncome(VALUE(e.target.value))
    const handleExpenseValue = (e) => dispatchExpense(VALUE(e.target.value))


    const handleReset = (e) => {
        clearIncome(e)
        clearExpense(e)
    }

    return (
        <BudgetContext.Provider value={{incomes, expenses}}>
            <br />
            <SaveData
                setIncomes={setIncomes}
                setExpenses={setExpenses}
                showWindow={show}
                closeWindow={() => setShow(false)} />
            <Tables
                clear={[clearIncome, clearExpense]}
                deleteRow={[deleteIncomeRow, deleteExpenseRow]}
                addEntry={[addIncome, addExpense]}
                nameChange={[handleIncomeName, handleExpenseName]}
                valueChange={[handleIncomeValue, handleExpenseValue]}
                nameSelect={[selectIncomeName, selectExpenseName]}/>
            <Leftover
                expenseSum={sum(expenses)}
                incomeSum={sum(incomes)} />
            <BudgetAction
                handleReset={handleReset}
                handleLoadSave={() => setShow(true)} />
        </BudgetContext.Provider>
    );
}

export default CreateBudget;
